<template>
    <form @submit.prevent="saveLine()">
        <div class="form-group">
            <label>Code <span v-if="!readOnly" class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="form.code" required>
        </div>

        <div class="form-group">
            <label>Libelle <span v-if="!readOnly" class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="form.libelle" required>
        </div>

        <div v-if="!readOnly" class="d-flex justify-content-end ">
            <button type="submit" class="btn btn-primary" :disabled="isLoading">
                <i class="fa-solid fa-save"></i> {{ buttonLabel }}
                <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </div>
    </form>
</template>
  
<script >
import $ from "jquery"
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'FormVille',
    inject: ['dialogRef'],
    props: {
        line: {
            type: Object,
            default: null,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            table: 'villes',
            isLoading: false,
            form: {}
        }
    },
    mounted() {
        if (this.line) {
            this.form = { ...this.line };
        }
    },
    computed: {
        buttonLabel() {
            return this.line ? "Mettre à jour" : "Enregistrer";
        },
    },
    methods: {
        saveLine() {
            this.isLoading = true
            this.axios.post('/api/'+this.table, this.form).then(response => {
                this.isLoading = false
                if (response.data.success === true) {
                    this.form = {}
                    $('#refresh' + this.table).click()
                    this.dialogRef.close()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                }
                else {
                    response.data.errors.forEach(element => {
                        this.$toast.add({
                            severity: 'warn',
                            summary: 'Oups !',
                            detail: element,
                            life: 7000
                        });
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        }
    }
})
</script>
    